import { connect } from 'react-redux';
import { Modal } from 'antd';
import React, { Component } from 'react';

import { fetchAllSlides } from '../../actions/Slideshow';
import SlideModal from './SlideshowsModal';

const $ = window.$;

class Slideshow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    componentDidMount() {
        // $(function () {
        //     $('[data-toggle="tooltip"]').tooltip();
        // });
        this.props.fetchAllSlides();
    }

    onAddClick() {
        console.log('show');
        this.setState({ showModal: true });
    }

    onModalCancel() {
        this.setState({ showModal: false });
    }

    onModalSubmit() {

    }

    renderSlides() {
        const { sortedSlides } = this.props;

        const rows = sortedSlides.map((slide, index) => {
            console.log(slide);
            return (
                <div className="order" key={slide.slideId}>
                    <div className="row" >
                        <div className="col-md-auto" style={{ textAlign: 'right', paddingTop: 8 }}>
                            <label>{`Order ${index + 1}`}</label>
                        </div>
                        <div className="col-md-auto product-img">
                            <img src="/resources/img/product3.png" alt="Product" />
                        </div>
                        <div className="col"></div>
                        <div className="col-md-auto">
                            <button type="button" className="btn btn-tooltip" data-toggle="tooltip" data-placement="top" title="Delete">
                                <img src="/resources/img/ic-delete.png" alt="delete" />
                            </button>
                        </div>
                    </div >
                </div>
            );
        });

        return (
            <div className="order-list" >
                {rows}
            </div>
        );
    }

    render() {
        const { showModal } = this.state;

        return (
            <div className="main-content">
                <div className="page-title">Slideshow</div>
                <div className="divider"></div>
                {this.renderSlides()}
                <div className="form-group add-more-btn" onClick={() => this.onAddClick()}>
                    <img src="/resources/img/ic-add.png" alt="" />
                    <label>Add Slide</label>
                </div>
                <Modal
                    visible={showModal}
                    closable={false}
                    footer={null}
                >
                    <SlideModal
                        onCancel={this.onModalCancel.bind(this)}
                        onAdd={this.onModalSubmit.bind(this)}
                    />
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { isSlideLoading, sortedSlides, slides } = state.slides;
    return { isSlideLoading, sortedSlides, slides };
}

export default connect(mapStateToProps, {
    fetchAllSlides
})(Slideshow);


// WEBPACK FOOTER //
// ./src/views/slideshow/index.js